import { Component, input } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { EmailListComponent } from '../email-list/email-list.component';

@Component({
  selector: 'app-comments-and-emails',
  standalone: true,
  imports: [MatTabsModule, EmailListComponent],
  template: `
    <mat-tab-group>
      <mat-tab label="Comments">
        <ng-content></ng-content>
      </mat-tab>
      <mat-tab label="Emails">
        <ng-template matTabContent>
          <div class="min-h-64 bg-white border border-slate-200">
            @if (source()) {
              <app-email-list [source]="source()"></app-email-list>
            }
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  `,
  styles: ``
})
export class CommentsAndEmailsComponent {
  source = input.required<{ resource: string; id: number }>();
}
